import { ForgotPasswordForm } from "@/components/forgot-password-form";
import { usePageMeta } from "../use-page-meta";

export default function ForgotPasswordPage() {
  usePageMeta("/auth/forgot-password", "비밀번호 찾기");
  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <ForgotPasswordForm />
    </div>
  );
}
